import React from 'react';

const LoadingSpinner = ({ text = 'Loading...' }) => (
  <div className="flex flex-col items-center justify-center py-16 gap-3">
    <div className="animate-spin rounded-full h-9 w-9 border-b-2 border-[#1F3864]"></div>
    <span className="text-sm text-gray-400">{text}</span>
  </div>
);

export default LoadingSpinner;
